// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__xY1zV","divider":"Footer_divider__1fMa6","content":"Footer_content__13H9m","logo":"Footer_logo__2iyoQ","footerMenuList":"Footer_footerMenuList__NipPv"};